const downloadData=({data,fileName,extension})=>{
    const downloadData = new Blob([data]);  
    const downloadURL = URL.createObjectURL(downloadData);
    const link = document.createElement('a');
    link.href = downloadURL;    
    link.download = `${fileName}.${extension}`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}
export default downloadData;